import { Component, Input } from '@angular/core';

import { BehaviorSubject } from 'rxjs';

import { BaseCtrlValueAccessorFormComponent } from '@sim/form';
import { ClassName } from '@sim/role';

@Component({
  selector: 'app-relations-manager',
  styleUrls: ['./relations-manager.component.scss'],
  templateUrl: './relations-manager.component.html',
})
export class RelationsManagerComponent extends BaseCtrlValueAccessorFormComponent<any> {

  @Input() classNames: ClassName[] = [];

  private readonly cardId$ = new BehaviorSubject<string | undefined>(undefined);
  @Input() set cardId(v: string | undefined) {
    this.cardId$.next(v);
  }
  get cardId() {
    return this.cardId$.value;
  }

  constructor() {
    super();
  }

}
